import * as React from "react";
const CopyToClipboardCapture = ({ formatSelection, children, className = void 0 }, ref) => {
  const _onCopy = (event) => {
    const selection = formatSelection(document.getSelection());
    event.clipboardData.setData("text/plain", selection);
    event.preventDefault();
  };
  return /* @__PURE__ */ React.createElement("div", { className, ref, onCopy: _onCopy }, children);
};
export default React.forwardRef(CopyToClipboardCapture);
